import "classlist-polyfill";
import "whatwg-fetch";
import "intersection-observer";

/* eslint-disable @typescript-eslint/ban-ts-ignore, @typescript-eslint/explicit-function-return-type */
if (typeof Element.prototype.matches != "function") {
    Element.prototype.matches =
        Element.prototype.webkitMatchesSelector ||
        // @ts-ignore
        Element.prototype.msMatchesSelector ||
        // @ts-ignore
        Element.prototype.matchesSelector;
}

if (typeof Element.prototype.closest != "function") {
    Element.prototype.closest = function closest(selector) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let currentElement: Element | null = this;

        while (currentElement) {
            if (currentElement.matches(selector)) {
                return currentElement;
            }

            currentElement = currentElement.parentElement;
        }

        // if we reach here, we're never going to find it
        return null;
    };
}

if (typeof Node.prototype.contains != "function") {
    Node.prototype.contains = function(other) {
        if (other == null) {
            return false;
        } else if (this == other) {
            return true;
        }
        // yay a bitmask API
        return (this.compareDocumentPosition(other) & document.DOCUMENT_POSITION_CONTAINED_BY) != 0;
    };
}
